import {
  Button,
  createStyles,
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MyPATDialog } from '../common';
import {
  toggleLicenseExpiredDialog,
  setLoggedInUser,
} from '../login/actions/userActions';

const styles = (theme: Theme) =>
  createStyles({
    txtRight: {
      textAlign: 'right',
    },
    primaryBtn: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '19px',
      height: '44px',
      color: '#fff',
      backgroundColor: '#1D7DEA',
      padding: '8px 30px',
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#1D7DEA',
      },
    },
    outlineBtn: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '19px',
      height: '44px',
      color: '#1D7DEA',
      backgroundColor: 'transparent',
      padding: '8px 30px',
      textTransform: 'capitalize',
      border: 'none',
      '&:hover': {
        border: 'none',
        backgroundColor: 'transparent',
      },
    },
    normalTxt: {
      fontSize: '16px',
      fontWeight: 'normal',
      lineHeight: '150%',
      color: '#333',
      width: '77%',
      margin: '15px auto 0 auto',
    },
    mxWidth500:{
      maxWidth: 500,
    },
    txtCenter: {
      textAlign: 'center',
    },
  });
interface Props extends WithStyles<typeof styles> {
  toggleLicenseExpiredDialog: (data: boolean) => void;
  setLoggedInUser: Function;
  showLicenseExpiredDialog: boolean;
}
class LicenseExpiredDialog extends Component<Props> {
  componentDidMount() {
    
    this.props.setLoggedInUser();
  }

  render() {
    
    const {
      classes,
      toggleLicenseExpiredDialog,
    } = this.props;
    return (
      <MyPATDialog
        dialogOpen={this.props.showLicenseExpiredDialog}
        dialogHasActions={true}
        dialogHeading={'License Expired'}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={() => toggleLicenseExpiredDialog(false)}
        isCustomBackground={false}
        isborderDialogAction={true}
        otherDialogProps={{
          fullWidth: false,
        }}
        customDialogActions={
          <>
            <div style={{textAlign: 'center'}}>
              {/* @frontend : add condition for disable button (disabled class name) */}
              {/* <Button className={classes.outlineBtn} autoFocus color="primary" onClick={handleViewChallenges}>
                View challenges
              </Button> */}
              <Button
                className={classes.primaryBtn}
                autoFocus
                color="primary"
                onClick={() => toggleLicenseExpiredDialog(false)}
              >
                Ok, got it!
              </Button>
            </div>
          </>
        }
      >
        <Grid container direction="row" justify="center" alignItems="center" className={classes.mxWidth500}>
          {/* <Grid className={classes.editImg}> */}
          <Grid>
            <img
              src="/assets/svg/license_expired.svg"
              alt="License Expired"
            />
          </Grid>
          <Grid>
            <Typography
              className={[
                classes.normalTxt,
                classes.txtCenter,
                // classes.marginLR,
              ].join(' ')}
            >
              Your license has expired. Please contact with Glorifire support team
              and Renew your account.
            </Typography>
          </Grid>
        </Grid>
      </MyPATDialog>
    );
  }
}

const mapStateToProps = (state: any) => ({
  showLicenseExpiredDialog:
    state.loginData.userData &&
    state.loginData.userData.showLicenseExpiredDialog,
});
const mapDispatchToProps = {
  toggleLicenseExpiredDialog,
  setLoggedInUser
};

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LicenseExpiredDialog));
